<template>
  <div>
    <el-tabs v-model="activeTabName" type="card" style="margin-top: 8px;" @tab-click="handleClick">
      <el-tab-pane :label="$t('CargoMsg.EmailParsingSettings')" name="emailParsingSettings">
        <div class="grid-view">
          <div class="main-content">
            <div style="width: 100%;margin-top: 5px; min-width: 1280px" class="cargo-advance-search">
              <el-form
                label-position="middle"
                label-width="100px"
              >
                <div class="el-form-item-wrapper" style="display: flex">
                  <el-form-item :label="$t('CargoMsg.TENANT_BUSINESS_NAME')">
                    <cargo-advance-select
                      no="1"
                      :select-type="selectTypeNames.TENANT"
                      :cache="false"
                      filterable
                      style="width: 230px;padding-left: 10px"
                      :custom-label="(item)=>`[${item.id}]${item.name}`"
                      callback-method-type="obj"
                      :default-value="String(filter.tenant)||''"
                      @parentCallBack="p => filter.tenant = p.value"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Partners.emailAddress2')">
                    <el-input v-model="filter.address" no="2" style="width: 230px;padding-left: 10px" clearable />
                  </el-form-item>
                  <div style="padding-left: 10px">
                    <el-button no="3" type="primary" @click="filter.pageNum=1;queryHandler()">
                      {{ $t('CargoMsg.Cargo_Query') }}
                    </el-button>
                    <el-button no="4" type="primary" @click="addHandler">
                      {{ $t('CargoMsg.Cargo_Add') }}
                    </el-button>
                    <el-button no="5" type="primary" @click="editHandler">
                      {{ $t('CargoMsg.Cargo_Edit') }}
                    </el-button>
                    <el-button no="6" type="danger" @click="deleteHandler">
                      {{ $t('CargoMsg.Cargo_OrderDelete') }}
                    </el-button>
                  </div>
                </div>
              </el-form>
            </div>
            <div class="app-main-inner-row row-grid" style="flex-grow: 1;">
              <cargo-ag-grid
                no="grid"
                config-module="101423"
                :column-defs="columnDefs"
                :row-data="rowData"
                :grid-params.sync="girdParams"
                :grid-options="gridOptions"
              />
            </div>
            <div class="app-main-inner-row row-pagination">
              <cargo-pagination
                no="pagination"
                config-module="101424"
                :total="total"
                :page.sync="filter.pageNum"
                :limit.sync="filter.pageSize"
                @pagination="queryHandler"
              />
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('CargoMsg.Cargo_GetReceiptSettings')" name="receiptSettings">
        <receipt-settings />
      </el-tab-pane>
    </el-tabs>
    <!-- 新增编辑弹框 -->
    <el-dialog
      ref="settingDialog"
      v-el-drag-dialog
      :visible.sync="settingDialog.visible"
      :title="settingDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="130px" label-position="right">
          <el-form-item :label="$t('CargoMsg.TENANT_BUSINESS_NAME')" class="lable-blue">
            <cargo-advance-select
              no="7"
              :select-type="selectTypeNames.TENANT"
              :disabled="settingDialog.isEdit"
              :cache="false"
              filterable
              :custom-label="(item)=>`[${item.id}]${item.name}`"
              callback-method-type="obj"
              :default-value="String(settingDialog.form.tenant)||''"
              :static-options="tenants"
              @parentCallBack="changeTenant"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.emailAddress2')" class="lable-blue">
            <el-input v-model="settingDialog.form.address" no="8" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.EmailPasswordAuthorizationCode')">
            <el-input v-model="settingDialog.form.password" no="9" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.SenderServer')">
            <el-input v-model="settingDialog.form.server" no="10" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Port')">
            <el-input v-model="settingDialog.form.serverPort" no="11" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.EmailPurpose')" class="lable-blue">
            <el-select v-model="settingDialog.form.purpose" no="12">
              <el-option v-for="(item,index) in EMAIL_PARSING_TYPE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="13" type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button no="14" @click="settingDialog.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { EMAIL_PARSING_TYPE } from '@/class/cargo/model/parameters/SystemConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import {
  deleteEmailServerConfig,
  queryEmailServerConfig,
  saveEmailServerConfig
} from '@/api/sysManage/AnalyzeChannelSettings'
import { getAllTenant } from '@/api/auth'
import ReceiptSettings from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/ReceiptSettings'

export default {
  name: 'AnalyzeChannelSettings',
  components: {
    AutoNumberInput,
    CargoAdvanceSelect,
    ReceiptSettings
  },
  data() {
    return {
      total: 0,
      isZh: this.$store.getters.language === 'zh',
      activeTabName: 'emailParsingSettings',
      EMAIL_PARSING_TYPE,
      selectTypeNames: TYPE_NAMES,
      loading: false,
      currentExpress: null,
      selectedRow: null,
      tenants: [],
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          filter: true
        }
      },
      filter: {
        tenant: '',
        address: '',
        pageNum: 1,
        pageSize: 50
      },
      settingDialog: {
        isEdit: false,
        title: this.$t('CargoMsg.AddOrEditEmail'),
        visible: false,
        form: {
          uuid: '',
          version: 0,
          tenant: '',
          tenantName: '',
          address: '',
          password: '',
          server: '',
          serverPort: '',
          purpose: 1
        }
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: 'TenantId',
          field: 'tenant',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.TENANT_BUSINESS_NAME'),
          field: 'tenantName',
          width: 200
        }, {
          headerName: this.$t('Partners.emailAddress2'),
          field: 'address',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.SenderServer'),
          field: 'server',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Port'),
          field: 'serverPort',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.EmailPasswordAuthorizationCode'),
          field: 'password',
          width: 200
        }, {
          headerName: this.$t('Warehouse.Purpose'),
          field: 'purpose',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.emailPurposeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t(this.$t('CargoMsg.Cargo_OperateBy')),
          field: 'modifiedBy',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t(this.$t('CargoMsg.Cargo_OperateTime')),
          field: 'dateModified',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ]
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    getAllTenant().then(res => {
      this.tenants = res.data
    })
  },
  mounted() {
    this.queryHandler()
  },
  methods: {
    handleClick() {},
    queryHandler() {
      this.loading = getLoading4Cxt(this)
      this.filter.address = this.filter.address.trim()
      queryEmailServerConfig(this.filter).then(res => {
        if (res.data) {
          if (this.gridApi) {
            this.gridApi.setRowData(res.data.list)
          } else {
            this.rowData = res.data.list
          }
          this.filter.pageNum = res.data.pageNum
          this.filter.pageSize = res.data.pageSize
          this.total = Number(res.data.total)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    addHandler() {
      this.settingDialog.form = {
        uuid: '',
        version: 0,
        tenant: '',
        tenantName: '',
        address: '',
        password: '',
        server: '',
        serverPort: '',
        purpose: 1
      }
      this.settingDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('SeaExport.Email2')
      this.settingDialog.isEdit = false
      this.settingDialog.visible = true
    },
    editHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length !== 1) {
        this.$message.warning(this.$t('common.tips.hasOneOnly'))
        return
      }
      this.settingDialog.form = { ...rows[0] }
      this.settingDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('SeaExport.Email2')
      this.settingDialog.isEdit = true
      this.settingDialog.visible = true
    },
    deleteHandler() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!(selectedRows.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.SelectDeleteEmail'))
        return
      }
      this.$confirm(this.$t('CargoMsg.DeleteEmailConfirm'), this.$t('Message.WarmReminder'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading4Cxt(this)
        const data = {
          keys: Array.from(selectedRows, p => p.uuid)
        }
        deleteEmailServerConfig(data).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.queryHandler()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    saveHandler() {
      const form = { ...this.settingDialog.form }
      if (!form.tenant) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.TENANT_BUSINESS_NAME'))
        return
      }
      if (!(form.address)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('Partners.emailAddress2'))
        return
      }
      if (!(form.purpose)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.EmailPurpose'))
        return
      }
      if (form.address) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(form.address)) {
          this.$message.warning(this.$t('CargoMsg.EnterCorrectEmail'))
          return
        }
      }
      const loading = getLoading4Cxt(this.$refs.settingDialog)
      form.tenant = Number(this.settingDialog.form.tenant)
      saveEmailServerConfig(form).then(() => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.settingDialog.visible = false
        this.queryHandler()
      }).finally(() => {
        loading.close()
      })
    },
    changeTenant(p) {
      this.settingDialog.form.tenant = p.value
      this.settingDialog.form.tenantName = p.name
    }
  }
}
</script>

<style lang="scss" scoped>

#app /deep/ .el-form-item__label {
  text-align: right;
}

.lable-blue ::v-deep {
  .el-form-item__label {
    color: #1F75D5 !important;
  }
}

</style>
